<template>
  <div>
    <px-view-header title="Notas fiscais" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-lista-notas-fiscais-header class="mb-3" @refresh="onRefresh" @change="onChangeFilters"/>
    <div class="mt-3" v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && (!notasFiscais.content || !notasFiscais.content.length)"
         class="text-center my-5">
      <div class="title font-weight-bold mt-3">
        Nenhuma nota fiscal encontrada
      </div>
    </div>
    <px-lista-notas-fiscais v-if="notasFiscais.content && notasFiscais.content.length"
                            :notas-fiscais="notasFiscais.content"/>
    <v-pagination
      class="mt-3"
      v-model="page"
      :length="pagesLimit"
      :total-visible="5"/>
  </div>
</template>

<script>
import ListaNotasFiscais from '@/modules/notas-fiscais/ListaNotasFiscais.vue';
import ListaNotasFiscaisHeader from '@/modules/notas-fiscais/ListaNotasFiscaisHeader.vue';
import { mapActions, mapGetters } from 'vuex';
import {
  RESET_PAGINATION,
  SET_FILTER_ACTION,
  SET_LIST_OPTIONS_ACTION,
  INIT_STATE_ACTION,
  SET_CURRENT_SESSION_STATE_ACTION,
} from '@/store/listagem-notas-fiscais/actions.type';
import paginationMixin from '@/mixins/pagination-mixin';
import NotasFiscaisService from './notas-fiscais-service';

const LIMIT = 30;
const PAGE = 1;

export default {
  mixins: [paginationMixin],
  data() {
    return {
      breadcrumbs: [
        { text: 'Gestão de compras' },
        { text: 'Notas fiscais' },
      ],
      notasFiscais: {
        content: [],
        total: 0,
      },
      loading: false,
      page: PAGE,
      pagesLimit: 1,
      optionsList: {
        page: PAGE,
        itemsPerPage: LIMIT,
        sortBy: '',
        sortDesc: false,
        multiSort: false,
      },
    };
  },
  computed: {
    ...mapGetters('listagemNotasFiscais', ['stringFilter', 'listOptions']),
    ...mapGetters('entidade', ['idEntidade']),
    ...mapGetters('user', ['user']),
  },
  methods: {
    ...mapActions('listagemNotasFiscais', {
      resetPagination: RESET_PAGINATION,
      updateFilter: SET_FILTER_ACTION,
      updateOptions: SET_LIST_OPTIONS_ACTION,
      initState: INIT_STATE_ACTION,
      setCurrentSessionState: SET_CURRENT_SESSION_STATE_ACTION,
    }),
    onRefresh() {
      this.getNotasFiscais();
    },
    onChangeFilters() {
      this.resetPagination();
      this.page = PAGE;
      this.getNotasFiscais();
    },
    onChangeOptions() {
      this.updateOptions(this.optionsToPage(this.listOptions, this.optionsList));
      this.getNotasFiscais();
    },
    setPagesLimit() {
      this.pagesLimit = Math.ceil(this.notasFiscais.total / LIMIT);
    },
    async getNotasFiscais() {
      this.loading = true;

      await this.updateFilter(this.stringFilter);
      const { limit, offset } = this.listOptions;

      NotasFiscaisService.getNotasFiscais({
        query: this.buildQuery(this.listOptions),
        limit,
        offset,
      })
        .then(({ data }) => {
          this.notasFiscais = data;
          this.setPagesLimit();
        })
        .finally(() => {
          this.setCurrentSessionState({
            idCurrentEntidade: this.idEntidade,
            idCurrentUser: this.user.id,
          });
          this.loading = false;
        });
    },
  },
  watch: {
    page(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.optionsList.page = newValue;
      this.onChangeOptions();
    },
  },
  created() {
    this.initState({
      idCurrentEntidade: this.idEntidade,
      idCurrentUser: this.user.id,
    });
    this.onChangeOptions();
  },
  components: {
    pxListaNotasFiscais: ListaNotasFiscais,
    pxListaNotasFiscaisHeader: ListaNotasFiscaisHeader,
  },
};
</script>
